/** 航拍/地图叠加工具箱常量 */

export const PHOTO_DENSITY_SOURCE = 'zhxt-ortho-photo-density';
export const PHOTO_DENSITY_LAYER = 'zhxt-ortho-photo-density-circle';
export const PHOTO_CLUSTER_COLORS = ['#22c55e', '#f59e0b', '#ef4444', '#3b82f6', '#a855f7', '#14b8a6'];

export const STATUS_TEXT = {
  draft: '草稿',
  ready: '就绪',
  awaiting_approval: '待确认',
  provisioning: '创建节点',
  modeling: '建模中',
  succeeded: '已完成',
  failed: '失败',
  cancelled: '已取消'
};

export const MAP_LAYER_STATUS_TEXT = {
  draft: '待上传源文件',
  queued: '排队切片',
  processing: '切片处理中',
  succeeded: '图层已就绪',
  failed: '切片失败',
  cancelled: '已取消'
};

export const MAP_LAYER_PHASE_TEXT = {
  provisioning: '创建切片节点',
  downloading: '下载源文件',
  converting: '转换矢量',
  tippecanoe: 'tippecanoe 切片',
  uploading: '上传成果',
  dry_run: '本地模拟切片',
  done: '已完成',
  failed: '失败'
};

export const ORTHO_BBOX_SOURCE = 'zhxt-ortho-bbox';
export const ORTHO_BBOX_FILL = 'zhxt-ortho-bbox-fill';
export const ORTHO_BBOX_LINE = 'zhxt-ortho-bbox-line';
export const ORTHO_BBOX_HANDLES = 'zhxt-ortho-bbox-handles';
export const ORTHO_BBOX_HANDLES_LAYER = 'zhxt-ortho-bbox-handles-circle';
